module.exports = __webpack_public_path__ + "static/img/12.7923e64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/12.png
// module id = Dpop
// module chunks = 0